import React from 'react';
import { defineMessages } from 'react-intl';
import YieldEmptyState from './YieldEmptyState';

const messages = defineMessages({
  title: {
    id: 'yield-management.empty-roster.title',
    defaultMessage: 'This class has no reservations.',
  },
  subtitle: {
    id: 'yield-management.empty-roster.subtitle',
    defaultMessage: 'Please check back later.',
  },
});

const EmptyRoster = () => <YieldEmptyState title={messages.title} subtitle={messages.subtitle} />;

export default EmptyRoster;
